import { PodcastConfig } from "components/podcast/PodcastProvider";
import PodcastPageConfig from "pages/podcast/config";

interface MediaSourceProps {
  podcastDetails?: PodcastConfig | null;
}

export const useMediaSource = ({ podcastDetails }: MediaSourceProps) => {
  const ms = new MediaSource();
  let sourceBuffer: SourceBuffer;

  const totalSegmentNumber = podcastDetails?.audio_urls?.length || podcastDetails?.video_urls?.length || 0;
  const startPlaying = () => {
    if (totalSegmentNumber === 1 && (podcastDetails?.audio_urls || podcastDetails?.video_urls)) {
      return (
        (podcastDetails?.audio_urls && `https://${podcastDetails?.audio_urls[0]}${PodcastPageConfig.ipfsGatewayUrl}`) ||
        (podcastDetails?.video_urls && `https://${podcastDetails?.video_urls[0]}${PodcastPageConfig.ipfsGatewayUrl}`) ||
        ""
      );
    }
    ms.addEventListener("sourceopen", onOpened, false);
    return URL.createObjectURL(ms);
  };

  const onOpened = async () => {
    if (ms.readyState === "open") {
      sourceBuffer?.abort();
    }

    let chunkUrls: string[] = [];
    if (podcastDetails?.audio_urls) {
      sourceBuffer = ms.addSourceBuffer("audio/mpeg");
      chunkUrls = podcastDetails.audio_urls;
    } else if (podcastDetails?.video_urls) {
      sourceBuffer = ms.addSourceBuffer(`video/mp4; codecs="avc1.4D4001,mp4a.40.2"`);
      chunkUrls = podcastDetails.video_urls;
    }

    const mediaBlob = await (await fetch(`https://${chunkUrls[0]}${PodcastPageConfig.ipfsGatewayUrl}`)).blob();
    const mediaBuff = await mediaBlob.arrayBuffer();

    let segmentNumber = 1;

    sourceBuffer.appendBuffer(mediaBuff);
    const loadSegment = async () => {
      if (segmentNumber < totalSegmentNumber) {
        getSegment(segmentNumber);
        segmentNumber++;
      }
    };

    const getSegment = async (segmentNumber: number) => {
      const mediaBlob = await (await fetch(`https://${chunkUrls[segmentNumber]}${PodcastPageConfig.ipfsGatewayUrl}`)).blob();
      const audioBuff = await mediaBlob.arrayBuffer();
      sourceBuffer.appendBuffer(audioBuff);
    };
    sourceBuffer.addEventListener("updateend", loadSegment);
  };

  return {
    startPlaying
  };
};
